export enum APPOINT_PROXY_CHOICES {
  DECLINE_PRESENCE = 'DECLINE_PRESENCE',
  CONFIRM_PRESENCE = 'CONFIRM_PRESENCE',
  APPOINT_PROXY = 'APPOINT_PROXY',
}
